<template>
  <div class="search-result-empty">
    <div class="empty-img">
      <img src="~@/assets/svg/empty-search-result.svg" alt="">
    </div>
    <div class="empty-container">
      <p class="empty-text">没有搜索到您想要的素材？</p>
      <p class="empty-operation-text">
        请 <span>更换搜索词</span> 或者直接联系
        <button class="service empty-btn" @click="$emit('service')">在线客服</button>
        一对一选曲
      </p>
      <p class="empty-service-text">客服电话：<span>135-2235-2793</span>（微信同步）</p>
      <div class="qrcode-container">
        <div class="img">
          <img src="~@/assets/image/guide/wechat-icon.png" alt="">
        </div>
        <p class="qrcode-tips">扫码添加客服微信</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchResultEmpty'
}
</script>

<style lang="scss" scoped>
.search-result-empty {
  text-align: center;
  padding-top: 60px;
  padding-bottom: 110px;

  .empty-img img {
    width: 160px;
    height: 140px;
    margin-bottom: 12px;
  }

  .empty-text {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 24px;
    margin-bottom: 30px;
  }

  .empty-operation-text {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.5);
    line-height: 24px;
    margin-bottom: 24px;

    span {
      color: #e52a0d;
    }

    .empty-btn {
      width: 74px;
      height: 24px;
      border-radius: 5px;
      border: 1px solid #e52a0d;
      outline: none;
      background: #fff;
      color: #e52a0d;
      cursor: pointer;
    }
  }

  .empty-service-text {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.5);
    line-height: 24px;
    margin-bottom: 12px;

    span {
      font-weight: bold;
    }
  }

  .qrcode-container img {
    width: 120px;
    height: 120px;
    margin-bottom: 8px;
  }

  .qrcode-tips {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.5);
    line-height: 20px;
  }
}
</style>
